<template>
<v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="50%"
          persistent>
  <v-card class="d-flex flex-column">
    <v-card-title class="primary white--text">
      {{getTitle}}
      <v-spacer/>
      <v-btn text elevation="0" color="white" small @click="sair">
        Fechar <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text class="py-4 flex-grow-1" 
      style="height: 80%;"
      v-if="value">
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card
            class="pa-4 text-center cursor-pointer custom-card"
            :class="{ 'selected-card': tipoLocal === 'fornecedor' }"
            @click="tipoLocal = 'fornecedor'"
            >
            <v-icon size="60" color="#efc00f">mdi-office-building</v-icon>
            <v-card-subtitle class="titulo white--text">Fornecedor</v-card-subtitle>
            <v-card-subtitle class="white--text">Cadastre-se para oferecer produtos e/ou serviços</v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card
            class="pa-4 text-center cursor-pointer custom-card"
            :class="{ 'selected-card': tipoLocal === 'comprador' }"
            @click="tipoLocal = 'comprador'"
            >
            <v-icon size="60" color="#efc00f">mdi-cash</v-icon>
            <v-card-subtitle class="titulo white--text">Comprador</v-card-subtitle>
            <v-card-subtitle class="white--text">Cadastre-se para encontrar produtos e serviços</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>      
    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="success" @click="sair" :disabled="loading">Cancelar</v-btn>
    </v-card-actions>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>  
</v-dialog>
</template>

<script>

export default {
  name: "CadastreSeCompradorDialog",
  components: {},
  props: ['value'],
  data () {
    return {
      tipoLocal: null,
      loading: false,
      concorda: false,
    }
  },
  watch: {
    tipoLocal: {
      deep: true,
      handler(newValue,oldValue) {
        if (newValue !== oldValue){
          this.$emit('onEscolha', newValue);
        }
      }
    },
  },  
  computed: {
    getTitle() {
      return "Informe o tipo de conta que deseja cadastrar.";
    }
  },
  methods: {
    sair(){
      this.$emit('input', false);
      this.$emit('onCancela', 'login');
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
.titulo {
  font-size: 2em;
  font-weight: bold;
}
.cursor-pointer {
  cursor: pointer;
}
.custom-card {
  background-color: #167ABC !important; /* Cor de fundo */
}
.selected-card {
  border: 2px solid #efc00f !important;
  background-color: #125d8f !important; /* Cor mais escura quando selecionado */
}
</style>